import React from 'react';
import { Link } from 'gatsby';
// eslint-disable-next-line import/no-unresolved
import scenttrunkLogo from 'assets/resources/pages/scenttrunk_logo.svg';
import { IoIosArrowRoundForward } from 'react-icons/io';
import OptimizedImage from '../../OptimizedImage';
import ImgHTML from '../../ImgHTML';
import useSitemap from '../../../graphql/staticQueries/useSitemap';

const Maintenance = () => {
  const pages = useSitemap();
  const desiredPage = '/case-studies/scent-trunk/';
  const altPage = '/case-studies/';
  const linkTo = pages.includes(desiredPage) ? desiredPage : altPage;
  return (
    <div className="awarded padd">
      <div className="container">
        <div className="main-beam bottom">
          <div className="row">
            <div className="col-lg-5 col-mn-12">
              <div className="desc-section">
                <div className="subtitle bigger">Maintenance and support</div>
                <div className="content">
                  <p>
                    Having a system developed and deployed is not the end of the
                    journey. Ulam Labs makes sure your product is always up to
                    date, stable and running.
                  </p>
                  <p>
                    Your product changes as your company does. Our job is to
                    make your market intelligence, observation and lessons
                    happen.
                  </p>
                  <p>
                    <strong>You will get:</strong>
                  </p>
                  <ul>
                    <li>System and infrastructure monitoring</li>
                    <li>Bugs and error fixes</li>
                    <li>Incremental feature development</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-12">
              <div className="image-section smaller">
                <OptimizedImage
                  src="pages/scenttrunk_photo.png"
                  className="img-fluid"
                  alt="scenttrunk photo"
                  title="scenttrunk photo"
                />
                <Link to={linkTo} className="company-link">
                  <div className="logo">
                    <ImgHTML src={scenttrunkLogo} alt="Scent Trunk Logo" />
                  </div>
                  <div className="link">
                    <div className="read-more">
                      See related project <IoIosArrowRoundForward />
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Maintenance;
